import createSDKRequest from '../../createSDKRequest';
import toRequest from './toRequest';
import fromResponse from './fromResponse';

export default createSDKRequest({
  toRequest,
  fromResponse,
});
